module.exports = __webpack_public_path__ + "static/img/GT.92200aa9.png";